import { useCallback, useEffect, useState } from "react";
import { CompareRajasthan } from "../../../models/rajasthan";
import { convertToString, getMonthFromDate } from "../../../extensions/date";
import {
  getDemoRajasthanDiscomData,
  getGnaTgnaData,
  getRajasthanCollectiveData,
  getRajasthanDiscomData,
  getRajasthanGenerationData,
  getRajasthanIsgsData,
  getRajDeep,
  getRajIntraGen,
  getRajIsgs,
  getRajReData,
  getRajTamData,
} from "../../../Rest_api/RestApi";
import {
  ChartDataParams,
  FormatChartData,
} from "../../../components/recharts/functions";
import { ExchangeColors } from "../../Dashboard/Exchange3/FormatData";
import {
  lightenColor,
  ReMixChart,
} from "../../../components/recharts/ReMixCharts";
import {
  formatDateForAPI,
  getLast7DaysDateRange,
  R_CHART_TYPES,
} from "../const";
import FilterMenu from "../../../components/FilterMenu";
import { DynamicDatePicker } from "../../../components/DatePicker";
import Loading from "../../../components/Loading";
import { ChartType, LegendKey } from "../../../models/chart_model";
import { SearchBox } from "../../../components/Search";
import { renderHourTick } from "../../../components/recharts/components";
import Tooltip from "../../../components/tooltip";
import MainPageContainer from "../../../components/MainPageContainer";
import NewFilterContainer from "../../../components/NewFilterContainer ";
import { useSelector } from "react-redux";
import SecondaryHeader from "../Demand/SecondaryHeader";
import LegendSummaryTable, {
  ChartTable,
  downloadChartTableCSV,
  downloadSummaryCSV,
} from "../../../components/table/SummaryTable";
import { stringToConsistentColor } from "../../../extensions/string";
import { AddDatesWithFileName } from "../../../helpers/helper";

const colors = [
  "orange",
  "red",
  "blue",
  "Maroon",
  "brown",
  "green",
  "darkgreen",
  "purple",
  "black",
  "cyan",
  "magenta",
  "gold",
  "teal",
  "navy",
];

const SHORT_TERM_LEGENDS = [
  {
    key: "IEX_RTM",
    label: "IEX RTM",
    color: ExchangeColors[8],
    stackId: "generation",
  },
  {
    key: "IEX_DAM",
    label: "IEX DAM",
    color: ExchangeColors[7],
    stackId: "generation",
  },
  {
    key: "IEX_GDAM",
    label: "IEX GDAM",
    color: ExchangeColors[4],
    stackId: "generation",
  },
  {
    key: "PXIL_RTM",
    label: "PXIL RTM",
    color: "purple",
    stackId: "generation",
  },
  {
    key: "PXIL_TAM",
    label: "PXIL TAM",
    color: "red",
    stackId: "generation",
  },

  {
    key: "IEX_TAM",
    label: "IEX TAM",
    color: "blue",
    stackId: "generation",
  },

  {
    key: "HPX_TAM",
    label: "HPX TAM",
    color: "green",
    stackId: "generation",
  },

  {
    key: "Deep_RA",
    label: "DEEP RA",
    color: "blue",
    stackId: "generation",
  },
];

const Y_AXIS = ["Price", "Short Term Procurement %"];

const LEGENDS = [
  {
    key: "ISGS_Gen",
    label: "Interstate Generation",
    color: ExchangeColors[3],
    stackId: "generation",
  },
  {
    key: "Intra_Gen",
    label: "Intrastate Generation",
    color: ExchangeColors[0],
    stackId: "generation",
  },

  {
    key: "RE_IntraState",
    label: "Intrastate RE Generation",
    color: "#00FF00",
    stackId: "generation",
  },
  {
    key: "RE_InterState",
    label: "OA RE Buy",
    color: "green",
    stackId: "generation",
  },
];

const DISCOM_LEGENDS = [
  // AVVNL Discom, JVVNL Discom, JDVVNL Discom
  {
    key: "Discom 1",
    label: "Discom 1",
    stackId: "discom",

    color: ExchangeColors[1],
  },
  {
    key: "Discom 2",
    label: "Discom 2",
    stackId: "discom",

    color: ExchangeColors[2],
  },
  {
    key: "Discom 3",
    label: "Discom 3",
    stackId: "discom",

    color: ExchangeColors[3],
  },
];

const TOTAL_DISCOM_LEGENDS = [
  {
    key: "Total_Load",
    label: "Total Discom Load",
    color: ExchangeColors[1],
    stackId: "discom",
  },
];

const KEYS = [
  {
    label: "Time Slot",
    key: "time",
    name: "Time Slot",
    firstKey: "time_block",
    secondKey: "date",
    values: ["time_block", "date"],
    isTime: true,
  },
  {
    label: "Date",
    key: "date",
    name: "Date",
    firstKey: "date",
    secondKey: undefined,
    values: ["date"],
    isTime: false,
  },
  {
    label: "Month",
    key: "month",
    name: "Month",
    firstKey: "month",
    secondKey: undefined,
    values: ["month"],
    isTime: false,
  },
];

const UNITS = ["MW", "MWh"];
const CONSUMPTION = [
  {
    label: "Total",
    value: TOTAL_DISCOM_LEGENDS,
  },
  {
    label: "By Discom",
    value: DISCOM_LEGENDS,
  },
];

export default function OverviewPrice() {
  const [data, setData] = useState<CompareRajasthan[]>([]);
  const [chartKeys, setChartKeys] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [discomData, setDiscomData] = useState<any[]>([]);
  const [tamData, setTamData] = useState<any[]>([]);
  const [selectedKey, setSelectedKey] = useState(KEYS[0]);
  const [uniqueEntities, setUniqueEntities] = useState<string[]>([]);
  const [chartData, setChartData] = useState<any[]>([]);
  const [TableData, setTableData] = useState<any[]>([]);
  const [selectedConsumption, setSelectedConsumption] = useState(
    CONSUMPTION[0]
  );
  const dataTab = useSelector((state: any) => state.viewMode.activeView);
  const [selectedUnit, setSelectedUnit] = useState(UNITS[0]);
  const [selectedEntity, setSelectedEntity] = useState<string[]>([]);
  const [legends, setLegends] = useState<LegendKey[]>([]);
  const [selectedChartType, setSelectedChartType] = useState(R_CHART_TYPES[1]);
  const activeTab = useSelector((state: any) => state.switchTabs.activeTab);
  const DefaultDates = useSelector(
    (state: any) => state.defaultDatesSetter.defaultDates
  );

  const getActivity = useCallback(() => {
    return [
      { label: "Consumption", value: selectedConsumption.value },
      { label: "Generation", value: LEGENDS },
      {
        label: "Buy",
        value: SHORT_TERM_LEGENDS.filter((item) =>
          item.stackId.includes("generation")
        ),
      },
      {
        label: "Sell",
        value: SHORT_TERM_LEGENDS.filter((item) =>
          item.stackId.includes("sell")
        ),
      },
    ];
  }, [selectedConsumption.value]);
  const [selectedActivity, setSelectedActivity] = useState(getActivity());

  const _handlefetchData = useCallback(async () => {
    if (DefaultDates[activeTab].defaultRangeDate === undefined) {
      return;
    }
    setLoading(true);
    const dates = DefaultDates[activeTab].defaultRangeDate;

    const startDateStr = formatDateForAPI(dates.startDate);
    const endDateStr = formatDateForAPI(dates.endDate);
    // Initiate all API calls concurrently
    const [
      isgsData,
      collectiveData,
      deepData,
      generationData,
      discomData,
      reGenData,
      tamData,
    ] = await Promise.all([
      // getRajasthanIsgsData({ startDate: startDateStr, endDate: endDateStr }),
      getRajIsgs({ startDate: startDateStr, endDate: endDateStr }),
      getRajasthanCollectiveData({
        startDate: startDateStr,
        endDate: endDateStr,
      }),
      getRajDeep({ startDate: startDateStr, endDate: endDateStr }),
      getRajIntraGen({ startDate: startDateStr, endDate: endDateStr }),
      getDemoRajasthanDiscomData(startDateStr, endDateStr),
      getRajReData({ startDate: startDateStr, endDate: endDateStr }),
      getRajTamData({ startDate: startDateStr, endDate: endDateStr }),
    ]);

    // Process the data concurrently
    const processedIsgsData: CompareRajasthan[] = isgsData
      .map((item) => ({
        ...item,
        value_mwh: item.value_mw / 4,
        entity: item.entity + " " + "ISGS Station",
        type: "ISGS",
        exchange: "ISGS",
        product: "Gen",
        time_block: item.slot,
        month: getMonthFromDate(item.date),
      }))
      .filter((item) => item.value_mw > 0);

    const processedCollectiveData: CompareRajasthan[] = collectiveData.map(
      (item) => {
        const isBuy = item.value_mw > 0;
        return {
          ...item,
          type: isBuy ? "Collective Buy" : "Collective Sell",
          time_block: item.time_slot,
          exchange: item.exchange__name,
          product: item.product__name,
          price_kwh: item.wt_mcp_rs_kwh,
          entity: item.exchange__name + " " + item.product__name,
          value_mwh: Math.abs(item.value_mw) / 4,
          value_mw: Math.abs(item.value_mw),
          month: getMonthFromDate(item.date),
        };
      }
    );
    const processedDeepData: CompareRajasthan[] = deepData
      .map((item) => {
        return {
          ...item,
          type: `Deep`,
          exchange: "Deep",
          product: "RA",
          entity: item.entity,
          time_block: item.slot,
          toEntity: item.entity,
          value_mwh: Math.abs(item.value_mw) / 4,
          value_mw: Math.abs(item.value_mw),
          month: getMonthFromDate(item.date),
        };
      })
      .filter((item) => item.value_mw > 0);
    console.log("Deep", deepData);

    console.log("Deep Data", processedDeepData);
    const processedGenerationData: CompareRajasthan[] = generationData
      .map((item) => ({
        ...item,
        type: "Intra Generation",
        value_mwh: item.value_mw! / 4,
        entity: item.entity + " " + "Intra Generator",
        value_mw: item.value_mw!,
        time_block: item.slot,
        month: getMonthFromDate(item.date),
      }))
      .filter((item) => item.value_mw > 0);

    const processedReData: CompareRajasthan[] = reGenData.map((item) => ({
      ...item,
      type: item.area + " RE Generation",
      value_mwh: item.value_mw / 4,
      price_kwh: 0,
      entity: item.energy_type + " RE",
      exchange: "RE",
      product: item.area,
    }));

    const processedTamData: CompareRajasthan[] = tamData.map((item) => ({
      ...item,
      type: "TAM",
      exchange: item.exchange,
      product: item.product,
      value_mwh: item.mw / 4,
      value_mw: item.mw,
      time_block: item.block,
      month: getMonthFromDate(item.date),
    }));

    console.log("Re", reGenData);
    console.log("RE Data", processedReData);

    // Combine all processed data
    const newData: CompareRajasthan[] = [
      ...processedIsgsData,
      ...processedCollectiveData,
      ...processedDeepData,
      ...processedGenerationData,
      ...processedReData,
      ...processedTamData,
    ];
    // unique entities are unique entity and toEntity
    const uniqueEntities = Array.from(
      new Set(newData.map((item) => [item.entity, item.toEntity]).flat())
    ).filter((item) => item !== undefined) as string[];
    setUniqueEntities(uniqueEntities);
    console.log("Unique Entities", uniqueEntities);
    setDiscomData(discomData);
    setLoading(false);
    setData(newData);
  }, [activeTab, DefaultDates]);

  useEffect(() => {
    _handlefetchData();
  }, [_handlefetchData]);

  useEffect(() => {
    setSelectedActivity(getActivity());
  }, [getActivity, selectedConsumption]);
  useEffect(() => {
    const processedDiscomData = discomData.map((item) => ({
      ...item,
      type:
        (selectedConsumption.label === "Total" ? "Total" : item.discom) +
        " Discom",
      exchange: selectedConsumption.label === "Total" ? "Total" : item.discom,
      product: "Load",
      value_mwh: (item.drawal_mw + item.load_shedding_mw) / 4,
      value_mw: item.drawal_mw + item.load_shedding_mw,
      time_block: item.block,
      month: getMonthFromDate(item.date),
    }));

    let filteredData = data.concat(processedDiscomData);
    if (selectedEntity.length > 0) {
      filteredData = filteredData.filter(
        (item) =>
          selectedEntity.includes(item.entity!) ||
          selectedEntity.includes(item.toEntity!)
      );
    }

    const params: ChartDataParams = {
      keys: selectedKey.secondKey
        ? [selectedKey.firstKey, selectedKey.secondKey]
        : [selectedKey.firstKey],
      tableKeys: ["date", "time_block"],
      groupBy: ["exchange", "product"],
      volumeKey: "value_mwh",
      aggregationKeys: ["value_mw"],
      priceKey: "price_kwh",
      averageKeys: ["value_mw"],
      averageDuplicationKeys: ["time_block"],
      data: filteredData,
    };

    const chartData = FormatChartData(params);
    let finalData = chartData.data.map((item) => {
      const total = selectedConsumption.value.reduce((acc, column) => {
        return acc + item[column.key + "_value_" + selectedUnit.toLowerCase()];
      }, 0);
      const shortTerm = SHORT_TERM_LEGENDS.filter(
        (e) => e.stackId == "generation"
      )
        .map((legend) => legend.key + "_value_" + selectedUnit.toLowerCase())
        .reduce((acc, column) => {
          return acc + item[column];
        }, 0);
      const percent = total > 0 ? (shortTerm / total) * 100 : 0;
      const dataItems = data.filter((dataItem) => {
        return (
          item.time_slot === dataItem.time_block &&
          item.date === dataItem.date &&
          (dataItem.type == "Collective Buy" ||
            dataItem.type == "Collective Sell")
        );
      });

      // const iex_dam = dataItems.find((dataItem: any) => dataItem.exchange__name === "IEX" && dataItem.product__name === "DAM") as any;
      // const iex_rtm = dataItems.find((dataItem: any) => dataItem.exchange__name === "IEX" && dataItem.product__name === "RTM") as any;
      // const iex_gdam = dataItems.find((dataItem: any) => dataItem.exchange__name === "IEX" && dataItem.product__name === "GDAM") as any;
      // const pxil_rtm = dataItems.find((dataItem: any) => dataItem.exchange__name === "PXIL" && dataItem.product__name === "RTM") as any;

      return {
        ...item,
        shortTerm: percent,
        // IEX_DAM_value_mw: iex_dam ? iex_dam.wt_mcp_rs_kwh : 0,
        // IEX_RTM_value_mw: iex_rtm ? iex_rtm.wt_mcp_rs_kwh : 0,
        // IEX_GDAM_value_mw: iex_gdam ? iex_gdam.wt_mcp_rs_kwh : 0,
        // PXIL_RTM_value_mw: pxil_rtm ? pxil_rtm.wt_mcp_rs_kwh : 0,
      };
    });

    let finalTableData = chartData.tableData
      ? chartData.tableData.map((item) => {
          const total = selectedConsumption.value.reduce((acc, column) => {
            return (
              acc + item[column.key + "_value_" + selectedUnit.toLowerCase()]
            );
          }, 0);
          const shortTerm = SHORT_TERM_LEGENDS.filter(
            (e) => e.stackId == "generation"
          )
            .map(
              (legend) => legend.key + "_value_" + selectedUnit.toLowerCase()
            )
            .reduce((acc, column) => {
              return acc + item[column];
            }, 0);
          const percent = total > 0 ? (shortTerm / total) * 100 : 0;
          const dataItems = data.filter((dataItem) => {
            return (
              item.time_slot === dataItem.time_block &&
              item.date === dataItem.date &&
              (dataItem.type == "Collective Buy" ||
                dataItem.type == "Collective Sell")
            );
          });

          // const iex_dam = dataItems.find((dataItem: any) => dataItem.exchange__name === "IEX" && dataItem.product__name === "DAM") as any;
          // const iex_rtm = dataItems.find((dataItem: any) => dataItem.exchange__name === "IEX" && dataItem.product__name === "RTM") as any;
          // const iex_gdam = dataItems.find((dataItem: any) => dataItem.exchange__name === "IEX" && dataItem.product__name === "GDAM") as any;
          // const pxil_rtm = dataItems.find((dataItem: any) => dataItem.exchange__name === "PXIL" && dataItem.product__name === "RTM") as any;

          return {
            ...item,
            shortTerm: percent,
            // IEX_DAM_value_mw: iex_dam ? iex_dam.wt_mcp_rs_kwh : 0,
            // IEX_RTM_value_mw: iex_rtm ? iex_rtm.wt_mcp_rs_kwh : 0,
            // IEX_GDAM_value_mw: iex_gdam ? iex_gdam.wt_mcp_rs_kwh : 0,
            // PXIL_RTM_value_mw: pxil_rtm ? pxil_rtm.wt_mcp_rs_kwh : 0,
          };
        })
      : [];
    setTableData(finalTableData);
    setChartData(finalData);
    setChartKeys(chartData.keys);
  }, [
    data,
    selectedKey,
    selectedConsumption,
    selectedEntity,
    discomData,
    selectedUnit,
  ]);

  const handleUnitChange = (index: number) => {
    setSelectedUnit(UNITS[index]);
  };
  const handleKeyChange = (index: number) => {
    setSelectedKey(KEYS[index]);
  };

  const summaryExtraKeys = selectedKey.isTime
    ? [
        "time_block", // Changed dateIndex to date
        selectedKey.values[1],
      ]
    : [selectedKey.values[0]];

  const summaryExtraLabels = selectedKey.values.map(
    (value) => (value === "date" ? "Date" : value) // Simplified label mapping
  );

  const tablePar = {
    legends: getActiveLegends(),
    data: chartData,
    tableData: TableData,
    itemsPerPage: 96,
    unit: selectedUnit,
    extraKeys: summaryExtraKeys,
    extraLabels: summaryExtraLabels,
    filename: AddDatesWithFileName({
      fileName: "Overview By Product",
      dates: DefaultDates[activeTab].defaultRangeDate,
    }),
  };
  return (
    <div className="page-container">
      {loading && <Loading />}
      <div className="gas-page-container">
        <NewFilterContainer>
          <div className="side-filters-container text-nowrap">
            <FilterMenu
              title="Interval"
              items={KEYS.map((item) => item.name)}
              selectedItems={[selectedKey.name]}
              onSelect={(item, index) => {
                handleKeyChange(index);
              }}
            />
            <FilterMenu
              title="Unit"
              items={UNITS}
              selectedItems={[selectedUnit]}
              onSelect={(item, index) => {
                handleUnitChange(index);
              }}
            />
            <FilterMenu
              title="Load"
              items={CONSUMPTION.map((item) => item.label)}
              selectedItems={[selectedConsumption.label]}
              onSelect={(item, index) => {
                setSelectedConsumption(CONSUMPTION[index]);
              }}
            />
            <FilterMenu
              title="Activity"
              items={getActivity().map((item) => item.label)}
              selectedItems={selectedActivity.map((item) => item.label)}
              setSelectedItems={(v: string[]) => {
                setSelectedActivity(
                  getActivity().filter((item) => v.includes(item.label)) as any
                );
              }}
            />
            <FilterMenu
              title="Chart Type"
              items={R_CHART_TYPES.map((item) => item.label)}
              selectedItems={[selectedChartType.label]}
              onSelect={(item, index) => {
                setSelectedChartType(R_CHART_TYPES[index]);
              }}
            />
          </div>
        </NewFilterContainer>

        <MainPageContainer>
          <SecondaryHeader />
          <div className="gas-chart-container">
            <div className="gas-heading">
              <h2 className="chartHeading w-60">By Product</h2>
              <div className="flex gap-x-6  justify-end">
                <SearchBox
                  options={uniqueEntities.map((item) => ({
                    label: item,
                    value: item,
                  }))}
                  isMany={true}
                  placeholder="Search Entities"
                  selectedOptions={selectedEntity.map((item) => ({
                    label: item,
                    value: item,
                  }))}
                  onChange={(item: any) => {
                    setSelectedEntity(item.map((item: any) => item.value));
                  }}
                />

                <button
                  onClick={() => {
                    dataTab.label === "Chart" &&
                      downloadChartTableCSV(tablePar);
                    //

                    dataTab.label === "Summary" && downloadSummaryCSV(tablePar);

                    dataTab.label === "Table" &&
                      downloadChartTableCSV(tablePar);
                  }}
                  className="downloadButton"
                >
                  Download Data
                </button>
              </div>
            </div>

            {dataTab.label === "Chart" && (
              <ReMixChart
                data={chartData}
                xDataKey={selectedKey.firstKey}
                xTick={
                  selectedKey.secondKey !== undefined
                    ? (value: any, index: any) => {
                        return renderHourTick(value, 10);
                      }
                    : undefined
                }
                secondXDataKey={selectedKey.secondKey}
                unit={selectedUnit}
                isTimeSlot={selectedKey.firstKey === "time_block"}
                onlyTitle={true}
                secondYAxisLabel="Price (Rs/kWh)"
                barCategoryGap={12}
                yAxisLabel={selectedUnit}
                showBrush={getShowBrush(chartData)}
                brushIndex={getBrushIndex()}
                legends={getActiveLegends()}
              />
            )}
            {dataTab.label === "Summary" && (
              <LegendSummaryTable {...tablePar} />
            )}
            {dataTab.label === "Table" && <ChartTable {...tablePar} />}
          </div>
          <div className="gna-footer-container">
            <div className="grid grid-cols-2 justify-between gap-5 ">
              <p className="gna-footer-text text-start col-span-1">
                Powered by <strong>GNA Energy</strong>
              </p>
              <strong className="gna-footer-text col-span-1 text-end">
                Demo Version
              </strong>
            </div>
          </div>
        </MainPageContainer>
      </div>
    </div>
  );

  function getActiveLegends() {
    const activityLegends =
      selectedActivity.length === 0
        ? selectedConsumption.value.concat(LEGENDS).concat(SHORT_TERM_LEGENDS)
        : selectedActivity.map((item) => item.value).flat();

    return activityLegends
      .map((legend) => {
        return {
          dataKey:
            legend.key +
            (legend.key.includes("Discom") ? "_Load_value_" : "_value_") +
            selectedUnit.toLowerCase(),
          name: legend.label,
          stroke: stringToConsistentColor(legend.key),
          stackId: selectedChartType.stackId ? legend.stackId : undefined,
          type: selectedChartType.value,
        };
      })
      .concat(
        SHORT_TERM_LEGENDS.concat(LEGENDS).map((legend) => {
          return {
            dataKey: legend.key + "_price_kwh",
            name: legend.label + " Price",
            stroke: stringToConsistentColor(legend.key),
            stackId: selectedChartType.stackId ? legend.stackId : undefined,
            type: ChartType.Line,
            yAxisId: "right",
          };
        })
      ) as LegendKey[];
  }

  function getShowBrush(chartData: any[]): boolean {
    if (selectedKey.firstKey === "time_block") {
      return chartData.length > 96 * 1;
    } else {
      return chartData.length > 7;
    }
  }

  function getBrushIndex(): { startIndex: number; endIndex: number } {
    if (selectedKey.firstKey === "time_block") {
      return { startIndex: 0, endIndex: 96 * 1 };
    } else {
      return { startIndex: 0, endIndex: 7 };
    }
  }
}
